/**
 * ProtectedPageLayout Component
 * 
 * High-order component that handles authentication and common page layout patterns.
 * Eliminates repetition of authentication setup and scroll animations.
 * 
 * Props:
 * - authPath: Path for authentication validation
 * - useScrollAnimations: Whether to enable scroll wobble animations (default: true)
 * - authHook: Custom authentication hook (default: useAuth)
 * - children: Page content
 */

import React from 'react';
import { useAuth, useCreateLinkAuth, AuthGuard } from '../../utils/auth';
import { useScrollWobble } from '../../utils/scrollAnimations';

const ProtectedPageLayout = ({ 
  authPath, 
  useScrollAnimations = true,
  authHook = null,
  children 
}) => {
  // Determine which auth hook to use based on path
  const getAuthHook = () => {
    if (authHook) return authHook;
    if (authPath === '/crtlnk9472xwz') return useCreateLinkAuth;
    return useAuth;
  };

  // Get authentication state
  const { isValidAccess, isLoading } = getAuthHook()(authPath);
  
  // Enable scroll animations if requested (must call hook unconditionally)
  useScrollWobble();
  
  // Note: useScrollWobble hook is called unconditionally to follow React rules
  // The hook itself can handle the animation logic internally

  return (
    <AuthGuard isLoading={isLoading} isValidAccess={isValidAccess}>
      <div className="app">
        {children}
      </div>
    </AuthGuard>
  );
};

export default ProtectedPageLayout;